"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
// TODO: Upgrade to use HasValueWidget
class UnorderedList extends fmko_ts_common_1.Widget {
    constructor() {
        super();
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        this.list = [];
        this.element = document.createElement("ul");
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    addListWidget(child) {
        this.list.push(child);
        const listElement = document.createElement("li");
        listElement.appendChild(child.element);
        child.removeFromParent();
        this.add(listElement);
    }
    getListWidgets() {
        let i = this.list.length;
        const copy = [];
        while (i--) {
            copy[i] = this.list[i];
        }
        return copy;
    }
    setValue(value) {
        for (let i; i++; value) {
            this.list[i].setValue(value[i]);
        }
    }
    getValue() {
        const result = [];
        for (let widget of this.list) {
            result.push(widget.getValue());
        }
        return result;
    }
}
exports.default = UnorderedList;
//# sourceMappingURL=UnorderedList.js.map